import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  debugDrawerOpened: [],
  debugDrawerClosed: [],
  debugDrawerToggled: [],
  copyJwtToClipboardRequested: [],
  copyJwtToClipboardFulfilled: [],
  copyStoreToClipboardRequested: [],
  copyStoreToClipboardFulfilled: []
})

export const DebugTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  debugDrawerOpen: false
})

// Redux reducers
export const debugDrawerOpened = (state, action) => {
  return state.merge({ debugDrawerOpen: true })
}

export const debugDrawerClosed = (state, action) => {
  return state.merge({ debugDrawerOpen: false })
}

export const debugDrawerToggled = (state, action) => {
  const { debugDrawerOpen } = state
  return state.merge({ debugDrawerOpen: !debugDrawerOpen })
}

export const copyJwtToClipboardRequested = state => {
  return state
}

export const copyJwtToClipboardFulfilled = state => {
  return state
}

export const copyStoreToClipboardRequested = state => {
  return state
}

export const copyStoreToClipboardFulfilled = state => {
  return state
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.DEBUG_DRAWER_OPENED]: debugDrawerOpened,
  [Types.DEBUG_DRAWER_CLOSED]: debugDrawerClosed,
  [Types.DEBUG_DRAWER_TOGGLED]: debugDrawerToggled,
  [Types.COPY_JWT_TO_CLIPBOARD_REQUESTED]: copyJwtToClipboardRequested,
  [Types.COPY_JWT_TO_CLIPBOARD_FULFILLED]: copyJwtToClipboardFulfilled,
  [Types.COPY_STORE_TO_CLIPBOARD_REQUESTED]: copyStoreToClipboardRequested,
  [Types.COPY_STORE_TO_CLIPBOARD_FULFILLED]: copyStoreToClipboardFulfilled
})



// WEBPACK FOOTER //
// ./src/redux/debugRedux.js